/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { t } from 'utils/translates';

// eslint-disable-next-line react/prefer-stateless-function
class TaskDescBlock extends Component {
  render() {
    return (
      <div>
        <article
          className="panel panel-heading_padding-large panel-default"
          id="desc"
        >
          <div className="panel-heading text-center panel-inner-border-bottom">
            <h2 className="panel-title">
              <i className="fa fa-info-circle" /> {t('Описание задачи')}
            </h2>
          </div>
          <div className="panel-body">
            {this.props.task.desc.split('\n').map((item, key) => (
              <span key={`TaskDescBlock${key + 1}`}>
                {item}
                <br />
              </span>
            ))}
          </div>
        </article>
        <article className="panel panel-heading_padding-large panel-default">
          <div className="panel-heading text-center panel-inner-border-bottom">
            <h2 className="panel-title">
              <i className="fa fa-check-circle-o" />{' '}
              {t('Подтверждение и проверка выполнения')}
            </h2>
          </div>
          <div className="panel-body">
            {[1, 3].includes(this.props.task.checkTypeId) ? (
              this.props.task.checkDesc.split('\n').map((item, key) => (
                <span key={`TaskDescStringItem${key + 1}`}>
                  {item}
                  <br />
                </span>
              ))
            ) : (
              <div>
                {this.props.task.taskQuiz &&
                  this.props.task.taskQuiz.map((item, quizKey) => (
                    <div key={`TaskQuizItem${quizKey + 1}`}>
                      <p>{item.ask}</p>
                      <ul>
                        {item.answer.map((answer, answerKey) => (
                          <li
                            key={`TaskQuizAnswerItem${quizKey + 1}-${answerKey +
                              1}`}
                          >
                            {answer}
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
              </div>
            )}
          </div>
        </article>
      </div>
    );
  }
}

TaskDescBlock.propTypes = {
  task: PropTypes.shape({
    desc: PropTypes.string.isRequired,
    checkDesc: PropTypes.string.isRequired,
    checkTypeId: PropTypes.number.isRequired,
    taskQuiz: PropTypes.arrayOf(
      PropTypes.shape({
        ask: PropTypes.string,
        answer: PropTypes.arrayOf(PropTypes.string)
      })
    ).isRequired
  }).isRequired
};

export default withRouter(TaskDescBlock);



// WEBPACK FOOTER //
// ./src/components/Tasks/_common/TaskDescBlock/TaskDescBlock.js